import React, { useEffect } from 'react'
import { List } from 'immutable'
import { injectIntl } from 'react-intl'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { connect } from 'react-redux'
import T from 'prop-types'
import { withRouter } from 'react-router-dom'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import SelectList from 'components/common/SelectList'
import { LAPTOP_BREAKPOINT } from 'helpers/responsive'
import 'styles/app/apps/tab-filter.scss'
import { setActiveSisenseData } from 'reducers/sisense/reducer'
import { logMonitorActivity } from 'reducers/environmentMonitor/reducer'
import messages from './translate'

function SisenseFilterBar({
  intl: { formatMessage },
  setSisenseData,
  embedLink,
  refreshTriggerInterval,
  slug,
  sisenseList,
  id,
}) {
  useEffect(() => {
    if (slug) {
      const { refreshTriggerInterval, embedLink, id } =
        sisenseList.find(({ slug: slugData }) => slugData === slug) ||
        sisenseList[0]

      if (id) {
        setSisenseData({ embedLink, refreshTriggerInterval, id })
      }

      return
    }

    setSisenseData({ embedLink, refreshTriggerInterval, id })
  }, [])

  const onFilterChange = (event, tabValue) => {
    const data = ifWindowWidthLessThan(LAPTOP_BREAKPOINT)
      ? event.index
      : tabValue
    const { refreshTriggerInterval, embedLink, id } = sisenseList.find(
      ({ id }) => id === data,
    )
    setSisenseData({ embedLink, refreshTriggerInterval, id })
  }

  const showMobileFilter = () => {
    const listForSelect = sisenseList
      .filter(({ disabled }) => !disabled)
      .map(({ name, id }) => ({
        value: id,
        text: name,
      }))

    return (
      <SelectList
        name="view-filter"
        label={formatMessage(messages.selectView)}
        list={List(listForSelect)}
        value={id}
        onChange={onFilterChange}
        className="sisense-view-filter"
        map={{
          index: 'value',
          text: 'text',
        }}
      />
    )
  }

  const showDesktopFilter = () => (
    <Tabs onChange={onFilterChange} value={id} variant="scrollable">
      {sisenseList.map(({ id, name }) => (
        <Tab
          key={`key_${id}`}
          value={id}
          disabled={false}
          className="filter-tab sales-dashboard"
          label={name}
        />
      ))}
    </Tabs>
  )

  return (
    <div className="type-filter">
      {ifWindowWidthLessThan(LAPTOP_BREAKPOINT)
        ? showMobileFilter()
        : showDesktopFilter()}
    </div>
  )
}

SisenseFilterBar.propTypes = {
  sisenseList: T.array.isRequired,
}

export default withRouter(
  connect(
    state => ({
      activeSite: state.getIn(['profile', 'siteId']),
    }),
    {
      setActiveSisenseData,
      logMonitorActivity,
    },
  )(injectIntl(SisenseFilterBar)),
)
